import { type BadgeProps } from '@quickmd-llc/design-system'

type BadgeVariant = NonNullable<BadgeProps['variant']>

export type PatientBadge = {
  label: string
  variant: BadgeVariant
}

// The primary account of a merged pair. `active` is the design-system teal that
// the legacy chart-list pill used, and the same teal the merge screens use.
export const MAIN_ACCOUNT_BADGE: PatientBadge = { label: 'Main account', variant: 'active' }

// Labels mirror the legacy `ui_kit_qmd` IdVerificationStatusTag copy; variants
// map each status to the design-system Badge color that matches the design.
const idVerificationBadges: Record<string, PatientBadge> = {
  warning: { label: 'ID warning', variant: 'warning' },
  failed: { label: 'ID failed', variant: 'error' },
  verified: { label: 'ID verified', variant: 'success' },
  processing: { label: 'ID processing', variant: 'active' },
  manuallyverified: { label: 'ID manually verified', variant: 'success' },
  unverified: { label: 'ID not verified', variant: 'error' },
  legacyverified: { label: 'ID legacy verified', variant: 'success' },
  requested: { label: 'ID request sent', variant: 'active' },
}

// Labels mirror the legacy `ui_kit_qmd` DrugScreenTag copy.
const drugScreenBadges: Record<string, PatientBadge> = {
  verified: { label: 'Drug screen verified', variant: 'success' },
  legacyunverified: { label: 'Prior drug screen, revalidate', variant: 'error' },
  addressunverified: { label: 'Patient changed state, revalidate', variant: 'error' },
  expired: { label: 'Drug screen expired', variant: 'error' },
  due: { label: 'No drug screen on file', variant: 'warning' },
  duesoon: { label: 'Drug screen due soon', variant: 'warning' },
  exempt: { label: 'Drug screen exempt', variant: 'default' },
}

export function getIdVerificationBadge(status?: string): PatientBadge | undefined {
  return status ? idVerificationBadges[status] : undefined
}

export function getDrugScreenBadge(status?: string): PatientBadge | undefined {
  return status ? drugScreenBadges[status] : undefined
}
